import {settings} from '@/src/config/settings'
import {isMobile} from '@/src/shared/utils/functions'

export const ExternalType = {
  Link: 'link',
  Image: 'image',
} as const

export const parseExternalLink = (externalType: ValuesOf<typeof ExternalType>, src: any) => {
  if (typeof src == 'string' && settings.NEXT_PUBLIC_APP_ENV === 'test') {
    return `${settings.NEXT_PUBLIC_MEDIA_HOST}${src}`
  }

  if (isMobile() && typeof window !== 'undefined') {
    if (typeof src == 'string') {
      if (src.startsWith('/upload/')) {
        src = `${settings.NEXT_PUBLIC_FRONTEND_URL}${src}`
      } else if (!src.startsWith(window.location.origin)) {
        src = src.replace(settings.NEXT_PUBLIC_FRONTEND_URL, window.location.origin)
      }
    }
  }

  if (
    typeof window !== 'undefined' &&
    typeof src == 'string' &&
    src.search('/upload/') >= 0 &&
    src.startsWith(window.location.origin)
  ) {
    src = src.replace(window.location.origin, settings.NEXT_PUBLIC_FRONTEND_URL)
  }

  return src
}
